import pack from '../../package.json';

const appVersion = pack.version;

// Development environment pointing to local NestJS backend on port 3000
// with MongoDB on port 27018
export const environment = {
  appVersion,
  basePath: 'http://localhost:3000/simit-rest-api/v1.7',
  filePath: 'http://localhost:3000',
  pdfPlaceholderPath: './assets/images/pdf-placeholder.png',
  production: false,
};

